import { Link } from 'react-router-dom';

export default function HeroBanner() {
  return (
    <section className="relative w-full h-[520px] md:h-[620px] overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dark%20cinematic%20movie%20theater%20atmosphere%20with%20dramatic%20spotlight%20and%20film%20reel%20texture%2C%20abstract%20artistic%20movie%20background%20with%20warm%20golden%20and%20deep%20black%20gradient%2C%20professional%20cinema%20aesthetic%2C%20no%20text%2C%20atmospheric%20lighting&width=1600&height=900&seq=hero-banner-bg&orientation=landscape"
          alt="91片库 - 海量高清影视资源"
          className="w-full h-full object-cover object-top"
          title="91片库高清影视资源平台"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-background-50"></div>

      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center px-4 md:px-6">
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-foreground-50 text-center mb-4">
          海量高清资源
          <span className="block text-primary-500 mt-2">免费在线观看</span>
        </h1>
        <p className="text-sm md:text-base text-foreground-300 text-center max-w-2xl mb-8 leading-relaxed">
          汇聚全网最新电影、电视剧、综艺、动漫，极速播放无广告，多线路智能切换，随时随地畅享精彩影视世界
        </p>
        <div className="w-full max-w-2xl relative">
          <input
            type="text"
            placeholder="搜索你想要的影视资源..."
            className="w-full px-6 py-4 text-base bg-background-50/70 backdrop-blur-md border border-background-200/50 rounded-full text-foreground-100 placeholder-foreground-500 focus:outline-none focus:border-primary-500/60 transition-all"
          />
          <button className="absolute right-2 top-1/2 -translate-y-1/2 px-6 py-2.5 bg-primary-500 hover:bg-primary-600 text-background-950 font-medium rounded-full text-sm transition-colors whitespace-nowrap cursor-pointer">
            <i className="ri-search-line mr-1.5"></i>搜索
          </button>
        </div>
        <div className="flex flex-wrap items-center justify-center gap-3 mt-6">
          <span className="text-xs text-foreground-500">热门搜索：</span>
          {['流浪地球3', '封神第二部', '繁花', '庆余年2', '沙丘2'].map((term) => (
            <Link
              key={term}
              to={`/category/dianying`}
              className="px-3 py-1.5 text-xs bg-background-100/60 backdrop-blur-sm border border-background-200/40 rounded-full text-foreground-400 hover:text-primary-400 hover:border-primary-500/40 transition-colors whitespace-nowrap cursor-pointer"
            >
              {term}
            </Link>
          ))}
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 h-24 bg-gradient-to-t from-background-50 to-transparent"></div>
    </section>
  );
}